export default __webpack_public_path__ + "static/media/andes_a_la_costa_10.95913421.JPG";